var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-card',{attrs:{"config":_vm.config}},[_c('el-button',{attrs:{"type":"text"},on:{"click":_vm.settings}},[_vm._v("去设置")]),_c('subject-modal',{ref:"modal"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }